import { cx } from '@linaria/core';
import { flagCls, buttonCls } from './flag-button.style.js';
import { jsx } from 'react/jsx-runtime';
import { DanishFlag } from './flags/Danish.js';
import { SpanishFlag } from './flags/Spanish.js';
import { GermanFlag } from './flags/German.js';
import { FrenchFlag } from './flags/French.js';
import { EnglishFlag } from './flags/English.js';
import { Tooltip } from '../overlays/tooltip/tooltip.js';

const FlagButton = ({
  language,
  active,
  tooltipPlacement,
  onClick
}) => {
  const flag = getFlag(language);
  const label = getLabel(language, active);
  const handleClick = evt => {
    evt.stopPropagation();
    onClick(language);
  };
  return /*#__PURE__*/jsx(Tooltip, {
    placement: tooltipPlacement,
    body: label,
    ariaType: "description",
    offsetPx: 0,
    children: ref => /*#__PURE__*/jsx("button", {
      ref: ref,
      className: cx(buttonCls, active && "active"),
      onClickCapture: handleClick,
      "data-flag": true,
      children: /*#__PURE__*/jsx("span", {
        className: flagCls,
        children: flag
      })
    })
  });
};
function getFlag(language) {
  switch (language) {
    case "English":
      return /*#__PURE__*/jsx(EnglishFlag, {});
    case "French":
      return /*#__PURE__*/jsx(FrenchFlag, {});
    case "German":
      return /*#__PURE__*/jsx(GermanFlag, {});
    case "Spanish":
      return /*#__PURE__*/jsx(SpanishFlag, {});
    default:
      return /*#__PURE__*/jsx(DanishFlag, {});
  }
}
function getLabel(language, isSelected) {
  const languageLabel = (() => {
    switch (language) {
      case "English":
        return "engelsk";
      case "French":
        return "fransk";
      case "German":
        return "tysk";
      case "Spanish":
        return "spansk";
      default:
        return "dansk";
    }
  })();
  return isSelected ? `Der bliver læst op på ${languageLabel}` : `Læs op på ${languageLabel}`;
}

export { FlagButton };
//# sourceMappingURL=flag-button.js.map
